module.exports = __webpack_public_path__ + "static/media/thumbnail.e47a3eb8.jpg";